import React, { ReactElement } from 'react';
import { Typography } from '@/components/Typography/Typography';
import { AccordionComponent } from '@/components/AccordionComponent/AccordionComponent';

type Props = {
  handleItemsChange: (value: string | number) => void;
};

const accordionItems: {
  id: string | number;
  triggerTitle: ReactElement | string;
  content: ReactElement | string;
  img?: string;
}[] = [
  {
    id: '0',
    triggerTitle: (
      <>
        <b>Efficient Rapid Response Suggestions:</b> Empower your team with quick and relevant
        drafts.
      </>
    ),
    img: '/img/freshdesk-integration/boost-your-support/freshdesk-boost-1.webp',
    content: '',
  },
  {
    id: '1',
    triggerTitle: (
      <>
        <b>Significantly Reduced Ticket Resolution Time:</b> Speed up resolution times for better
        customer satisfaction.
      </>
    ),
    img: '/img/freshdesk-integration/boost-your-support/freshdesk-boost-2.webp',
    content: '',
  },
  {
    id: '2',
    triggerTitle: (
      <>
        <b>Relevant Responses to Routine Customer Queries:</b> Deliver responses that are tailored
        to all standard inquiries.
      </>
    ),
    img: '/img/freshdesk-integration/boost-your-support/freshdesk-boost-3.webp',
    content: '',
  },
  {
    id: '3',
    triggerTitle: (
      <>
        <b>Seamless Integration and Real-Time Data Access:</b> Ensure relevant responses across all
        channels with integrated, up-to-date information.
      </>
    ),
    img: '/img/freshdesk-integration/boost-your-support/freshdesk-boost-4.webp',
    content: '',
  },
  {
    id: '4',
    triggerTitle: (
      <>
        <b>Superior Performance and Cost-Effectiveness:</b> Save tens of thousands of dollars with
        optimized operations.
      </>
    ),
    img: '/img/freshdesk-integration/boost-your-support/freshdesk-boost-5.webp',
    content: '',
  },
];

export const AccordionPart = ({ handleItemsChange }: Props) => {
  return (
    <div className="flex flex-grow lg:w-1/2 flex-col items-center justify-center md:gap-6-vw gap-5 z-10">
      <div className="lg:max-w-[36.528vw] md:max-w-[60%] flex flex-col h-full md:gap-8-vw gap-8 lg:py-14-vw">
        <div className="flex justify-center">
          <Typography as="h2" $weight="700" $type="Heading2" className="font-formula">
            Boost Your Support Team Productivity with AI-Powered Freshdesk Integration
          </Typography>
        </div>
        <div>
          <AccordionComponent
            triggerClassName="font-jamjuree"
            triggerType="PMedium"
            triggerWeight="PMedium"
            aspectImage="aspect-square"
            contentClassName="max-md:gap-0"
            accordionItems={accordionItems}
            handleItemsChange={handleItemsChange}
            hideOnMobileBreakPoint="(min-width: 1024px)"
          />
        </div>
      </div>
    </div>
  );
};
